var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_2344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7068 22.7938L17.7378 16.8248C19.3644 14.8354 20.1642 12.2969 19.9716 9.73432C19.7791 7.17179 18.609 4.78129 16.7034 3.05728C14.7977 1.33327 12.3024 0.407651 9.73342 0.471883C7.16447 0.536114 4.71849 1.58528 2.9014 3.40237C1.08431 5.21946 0.0351379 7.66545 -0.029094 10.2344C-0.0933258 12.8034 0.832293 15.2987 2.5563 17.2043C4.28031 19.11 6.67081 20.2801 9.23334 20.4726C11.7959 20.6651 14.3344 19.8654 16.3238 18.2388L22.2928 24.2078C22.4814 24.3899 22.734 24.4907 22.9962 24.4884C23.2584 24.4862 23.5092 24.381 23.6946 24.1956C23.88 24.0102 23.9852 23.7594 23.9875 23.4972C23.9897 23.235 23.8889 22.9824 23.7068 22.7938ZM9.99978 18.5008C8.41753 18.5008 6.87081 18.0316 5.55522 17.1525C4.23963 16.2735 3.21425 15.024 2.60875 13.5622C2.00324 12.1004 1.84482 10.4919 2.1535 8.94004C2.46218 7.38819 3.22411 5.96272 4.34293 4.8439C5.46175 3.72508 6.88721 2.96316 8.43906 2.65448C9.99091 2.34579 11.5994 2.50422 13.0613 3.10972C14.5231 3.71522 15.7725 4.7406 16.6515 6.0562C17.5306 7.37179 17.9998 8.91851 17.9998 10.5008C17.9974 12.6218 17.1538 14.6552 15.654 16.155C14.1542 17.6548 12.1208 18.4984 9.99978 18.5008Z",
    fill: "#8897AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_2344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.5da757d6804d71c3ba2c58ef7c90b4eb.svg";
export { ForwardRef as ReactComponent };